module.exports = __webpack_public_path__ + "static/media/圖2.8313f9f0.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/香蕉磅蛋糕/圖2.JPG
// module id = 931
// module chunks = 0